export default {
  'screenReader.widgetMenu': '<%=widgetName%> widget menu'
};
